var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import BS_Modal from 'bootstrap/js/dist/modal';
export class Modal {
    static init() {
        this.htmlElement = $('#main-modal');
        this.bsModal = new BS_Modal(this.htmlElement.get(0), { backdrop: 'static', keyboard: false });
    }
    static show(modalName, dismissCallback, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'get_modal',
                    'modal_name': modalName,
                    'data': data,
                    'language': $('html').attr('lang').substring(0, 2)
                },
                dataType: 'html',
            });
            this.htmlElement.find('.modal-content').empty().append(response);
            if (dismissCallback) {
                this.htmlElement.off('hidden.bs.modal').on('hidden.bs.modal', function (event) {
                    dismissCallback();
                });
            }
            this.bsModal.show();
        });
    }
    static hide() {
        this.bsModal.hide();
    }
}
